import {Yii} from "libraries/interfaces/Yii";
// angular
import { Component, Input, ViewChild, TemplateRef } from '@angular/core';
import { FormBuilder } from '@angular/forms';

// Services
import { FormService }  from "libraries/service/form/form.service";

import { GenericForm } from '../generic-the-good-one';

import { Config } from './config';
import { HttpClient } from "@angular/common/http";

@Component({

    selector: 'login-form',
    templateUrl: './login-form.component.html',
    styleUrls: ['./login-form.component.scss'],
})
export class LoginFormComponent extends GenericForm {

    Yii = Yii;

    @Input()
    public config: Config = new Config();

    /**
     * Every ViewChild is template
     * With this we give the possibilities to display the template we want dynamically
     * Every template (fieldset) as to have a view child reference
     */
    @ViewChild('login')
    public readonly login: TemplateRef<HTMLElement>;

    constructor(public fb: FormBuilder,
        public formService?: FormService,
        public http?: HttpClient) {
        super(fb, formService);
    }

    public onSubmit({ value, valid }: { value: any, valid: boolean }): void {
        if (valid && value.login && value.login.pwd !== '' && value.login.uid !== '') {
            this.formService.setData(value);
            this.sendrequest.emit(value);
        }
    }
}
